import { MASKED_PHONE_NUMBER_LENGTH } from ".";
import { INPUT_MASKS, maskInput } from "../../../../lib/formatting";
import StyledInput, {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "../StyledInput/StyledInput";

type Props = Omit<StyledInputProps, "value" | "onChange"> & {
  value: string;
  onChange: (v: string) => void;
} & StyledInputLabelProps &
  StyledInputValidationProps;

export default function PhoneNumberInput({ value, onChange, ...props }: Props) {
  const onChangeText = (nextVal: string) => {
    onChange(nextVal.replace(/\D/g, ""));
  };

  return (
    <StyledInput
      {...props}
      value={maskInput(INPUT_MASKS.phoneNumber, value)}
      onChange={(e) => onChangeText(e.currentTarget.value)}
      maxLength={MASKED_PHONE_NUMBER_LENGTH}
      showPopover={false}
    />
  );
}
